import { createSvgIcon } from '@mui/material'

export const ReportsIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.19651 17.5C10.0663 17.5 12.393 15.1622 12.393 12.2788H7.19651V7.05762C4.32673 7.05762 2 9.3954 2 12.2788C2.00057 15.1622 4.32673 17.5 7.19651 17.5ZM6.06041 8.36177V12.2788V13.4203H7.19651H11.095C10.6025 15.116 9.04096 16.3585 7.19651 16.3585C4.95783 16.3585 3.1361 14.5287 3.1361 12.2788C3.13667 10.4256 4.37331 8.85661 6.06041 8.36177Z'
      fill='currentColor'
    />
    <path d='M15.5863 14.8163H14.791V16.653H15.5863V14.8163Z' fill='currentColor' />
    <path d='M17.1888 10.5524H16.3936V16.6531H17.1888V10.5524Z' fill='currentColor' />
    <path d='M18.7933 7.45197H17.998V16.653H18.7933V7.45197Z' fill='currentColor' />
    <path d='M20.3949 10.3578H19.5996V16.6531H20.3949V10.3578Z' fill='currentColor' />
    <path d='M22.0003 13.3204H21.2051V16.653H22.0003V13.3204Z' fill='currentColor' />
    <path
      d='M7.75195 11.7212H12.9485C12.9485 8.83778 10.6217 6.5 7.75195 6.5V11.7212Z'
      fill='currentColor'
    />
  </svg>,
  'ReportsIcon',
)
